import { render, staticRenderFns } from "./PassengerInfo.vue?vue&type=template&id=640f6795&"
import script from "./PassengerInfo.vue?vue&type=script&lang=js&"
export * from "./PassengerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports